// rfc tab for boilerplate
import React, { useEffect, useState } from 'react';
import { Grid, Button, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogActions } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link, useNavigate } from "react-router-dom";
import useRequestResource from '../../hooks/useRequestResource';
import ColorBox from "../../components/ColorBox";
import {Search, SearchIconWrapper, StyledInputBase} from '../../components/utils/SearchBar'
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { FaSort, FaSortDown, FaSortUp} from "react-icons/fa";

export default function Summary() {
    const {getResourceList, resourceList, deleteResource, searchResources, searchList, currentListSize} = useRequestResource({ endpoint: "auth", query: `instruments`, resourceLabel: "Instrument List" });
    const [open, setOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);
    let offset = 25;
    const [exp, setExp] = useState("")
    const [sorting_query, setSortingQuery] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        getResourceList();
    }, [getResourceList])

    const handleConfirmDelete = (id) => {
        setIdToDelete(id);
        setOpen(true);
    }

    const handleDeleteClose = () => {
        setOpen(false);
    }

    const handleDelete = () => {
        setOpen(false);
        deleteResource(idToDelete);
    }

    const fetchData = () => {
        getResourceList(offset, sorting_query)
    }

    const headerStyle = {
        color: "white",
        backgroundColor: "#64748B",
        padding: "10px",
        fontFamily: "Arial"
    };

    const is_manager = localStorage.getItem("is_manager")
    const has_edit_access = (is_manager === "true")

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            searchData();
        }
    };

    useEffect(() => {
        if (exp !== "") {
            searchData()
        } else {
            getResourceList(0, sorting_query)
        }
    }, [sorting_query, getResourceList])

    function changeSort(elem) {
        setSortingQuery(elem)
    }

    function toggleSort(elem) {
        if (sorting_query === elem || sorting_query === `-${elem}`) {
            setSortingQuery(null)
        } else {
            setSortingQuery(elem)
        }
    }

    const searchData = () => {
        searchResources(exp, sorting_query)
    }

    const getList = () => {
        if (exp !== "") {
            return searchList.results
        } else {
            return resourceList.results
        }
    }

    return (
        <div>
            <div style={{ height: "20px" }} />

            <TableContainer component={Paper}>
            <h3 style={headerStyle}>
                    Instrument List
                </h3>

                 
                <Grid item xs={12} >
                    <Search fullWidth>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ 'aria-label': 'search' }}
                            fullWidth
                            id="Instruments"
                            label="Instruments"
                            value={exp}
                            onChange={(e) => setExp(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                    </Search>
                </Grid>
                
                <div style={{ height: "20px" }} />
                
                <Table sx={{ minWidth: 360 }} size="small">
                    <TableHead width="100%">
                        <TableRow>
                            <TableCell align="center" width="25%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("project__project_name")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Project Name</div><div>{sorting_query === "project__project_name" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-project__project_name")}></FaSortUp> : 
                                    sorting_query === "-project__project_name" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("project__project_name")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="25%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("project__client_name")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Customer Name</div><div>{sorting_query === "project__client_name" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-project__client_name")}></FaSortUp> : 
                                    sorting_query === "-project__client_name" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("project__client_name")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="25%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("instrument_name")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Instrument Name</div><div>{sorting_query === "instrument_name" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-instrument_name")}></FaSortUp> : 
                                    sorting_query === "-instrument_name" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("instrument_name")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="25%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("instrument_location__location_name")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Location</div><div>{sorting_query === "instrument_location__location_name" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-instrument_location__location_name")}></FaSortUp> : 
                                    sorting_query === "-instrument_location__location_name" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("instrument_location__location_name")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            getList().map((r) => {
                                return (
                                    <TableRow key={r.id} onClick={() => {
                                        navigate(`/${r.id}/datatable`)
                                    }}>
                                        <TableCell align="center" width="25%">
                                            {r.project_name}
                                        </TableCell>
                                        <TableCell align="center" width="25%">
                                            {r.client_name}
                                        </TableCell>
                                        <TableCell align="center" width="25%">
                                            {r.instrument_name}
                                        </TableCell>
                                        <TableCell align="center" width="25%">
                                            {r.instrument_location_name}
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
                
            </TableContainer>
            {exp !== "" || currentListSize.current < offset ? <div></div> : <div className='centered-container'>
                <Button onClick={fetchData}>
                            LOAD MORE!
                </Button>
            </div>}
        </div>
    )
}
